import { render } from "./PortafolioPage.vue?vue&type=template&id=597c8792"
import script from "./PortafolioPage.vue?vue&type=script&lang=js"
export * from "./PortafolioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__